module.exports = __webpack_public_path__ + "static/checklist_logo-47bd8067717acbb423cc1e76439b9fe6.png";